<div class="flex flex-col h-full w-full">
  <!-- Overlay for modal -->
  @if (visible) {
    <div
      class="fixed inset-0 bg-black/[0.32] dark:bg-black/60 h-screen w-screen z-[60]"
    ></div>
  }

  <!-- Main modal -->
  <div
    [style.display]="visible ? 'flex' : 'none'"
    tabindex="-1"
    class="fixed inset-0 z-[70] flex justify-center items-center overflow-y-auto"
  >
    <!-- Modal content -->
    <div class="max-w-6xl bg-white rounded-2xl shadow-2xl dark:bg-gray-900">
      <!-- Modal header -->
      <div
        class="flex items-center justify-between p-1 md:p-1 rounded-t dark:border-gray-600"
      >
        <button
          type="button"
          class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-xs 2xl:text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
          (click)="closeModal()"
        >
          <svg
            class="w-3 h-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
          <span class="sr-only">Close modal</span>
        </button>
      </div>
      @if (!isManager) {
        <!-- Modal body -->
        <section class="bg-white dark:bg-gray-900">
          <div class="px-8 mx-auto">
            <!-- Title, update or claim field -->
            <div class="mb-4 flex flex-col gap-3">
              <h2
                class="text-base 2xl:text-xl font-bold text-gray-900 dark:text-white"
              >
                {{ owner ? "Update the Field" : "Claim a New Field" }}
              </h2>
            </div>
            <form>
              <!-- 01: Field Name -->
              <div class="grid gap-4 sm:grid-cols-2 sm:gap-6">
                <div class="sm:col-span-2">
                  <label
                    for="fieldName"
                    class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                    >Field Name
                    <span class="text-red-500" aria-hidden="true"
                      >*</span
                    ></label
                  >
                  <input
                    type="text"
                    name="fieldName"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                    placeholder="Name the Field"
                    id="fieldName"
                    [value]="formData.field_name"
                    (input)="updateFormValue('field_name', $event)"
                  />
                </div>
              </div>

              <!-- Entity Group (shared with manager-on-behalf flow) -->
              <ng-container *ngTemplateOutlet="entitySectionTpl" />

              <!-- Target Water Group -->
              <div class="grid gap-4 sm:grid-cols-11 sm:gap-6 mt-5">
                <!-- 02: Total Target Water -->
                <div class="sm:col-span-4">
                  <label
                    for="total_target_water"
                    class="flex items-center gap-1 mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                    >Total Target Water
                    <span class="text-red-500" aria-hidden="true">*</span>
                    <app-info-popover
                      class="ml-1 pb-1"
                      [infoType]="'totalTargetWater'"
                    ></app-info-popover
                  ></label>
                  <input
                    type="number"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                    placeholder="Type Your Total Target Water"
                    id="total_target_water"
                    [value]="formData.total_target_water"
                    (change)="updateFormValue('total_target_water', $event)"
                  />
                </div>
                <!-- 03: Total Target Type -->
                <div class="sm:col-span-3">
                  <label
                    for="total_target_type"
                    class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                    >Target Type
                    <span class="text-red-500" aria-hidden="true"
                      >*</span
                    ></label
                  >
                  <select
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                    id="total_target_type"
                    [value]="formData.total_target_type"
                    (change)="updateFormValue('total_target_type', $event)"
                  >
                    <option value="ET">ET</option>
                    <option value="Applied Water">Applied Water</option>
                  </select>
                </div>
                <!-- 04: Total Target Water Unit -->
                <div class="sm:col-span-2">
                  <label
                    for="total_target_water_unit"
                    class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                    >Water Unit
                    <span class="text-red-500" aria-hidden="true"
                      >*</span
                    ></label
                  >
                  <select
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                    id="total_target_water_unit"
                    [value]="formData.total_target_water_unit"
                    (change)="
                      updateFormValue('total_target_water_unit', $event)
                    "
                  >
                    <option value="Feet">Feet</option>
                    <option value="Inches">Inches</option>
                  </select>
                </div>
                <!-- Deficit Irrigation -->
                <div class="sm:col-span-2">
                  <div class="gap-2 flex flex-col">
                    <div class="flex flex-row items-center gap-2">
                      <label
                        for="is_deficit_irrigation"
                        class="block text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                        >Deficit Irrigation</label
                      >
                      <app-graph-popover-instruction
                        [infoType]="'deficitIrrigation'"
                      />
                    </div>
                    <app-dropdown
                      class="text-xs 2xl:text-sm"
                      [dropdownPlacement]="'bottom'"
                      [options]="deficitIrrigationOptions"
                      [selectedKey]="formData.is_deficit_irrigation ?? ''"
                      [hasNoneOption]="true"
                      [noneOutputValue]="null"
                      [noneLabel]="''"
                      keyField="value"
                      labelField="label"
                      outputField="value"
                      (onClickOption)="
                        updateFormValue('is_deficit_irrigation', $event)
                      "
                    />
                  </div>
                </div>
              </div>
              <!-- Crop Group 01-->
              <div class="grid gap-4 sm:grid-cols-11 sm:gap-6 mt-5">
                <div class="col-span-4 w-full flex flex-col">
                  <div class="flex flex-row items-center gap-1 mb-2">
                    <label
                      class="block text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                      >Crop 1
                      <span class="text-red-500" aria-hidden="true"
                        >*</span
                      ></label
                    >
                    <app-graph-popover-instruction
                      [placement]="'right'"
                      [infoType]="'coverCrop'"
                    />
                  </div>
                  <!-- Visibility directive to reset the form control inside -->
                  <app-dropdown
                    class="text-xs 2xl:text-sm"
                    *ngIf="visible"
                    [dropdownPlacement]="'bottom'"
                    [useSearch]="true"
                    [options]="crops ?? []"
                    [selectedKey]="selectedCrops(formData.crop_type_01)"
                    [hasNoneOption]="false"
                    keyField="id"
                    labelField="crop_type"
                    outputField="crop_type"
                    (onClickOption)="updateFormValue('crop_type_01', $event)"
                  />
                </div>
                <div class="col-span-3 w-full flex flex-col">
                  <label
                    for="irrigation_methods_01"
                    class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                    >{{ irrigationDropdownLabel }}
                    <span class="text-red-500" aria-hidden="true"
                      >*</span
                    ></label
                  >
                  <app-dropdown
                    class="text-xs 2xl:text-sm"
                    [dropdownPlacement]="'bottom'"
                    [options]="irrigationMethodsOptions"
                    [(selectedKey)]="firstCropIrrigationMethodSelectedOption"
                    [hasNoneOption]="false"
                    keyField="key"
                    labelField="value"
                    outputField="value"
                  />
                </div>
                <!--Start and End Dates-->
                <div class="col-span-2 w-full">
                  <label
                    for="ls_start_01"
                    class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                    >Start Date
                    <span class="text-red-500" aria-hidden="true"
                      >*</span
                    ></label
                  >
                  <div class="relative max-w-sm">
                    <div
                      class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                    >
                      <svg
                        class="w-4 h-4 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
                        />
                      </svg>
                    </div>
                    <input
                      [min]="waterYearMinDate"
                      [max]="waterYearMaxDate"
                      type="date"
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Select date"
                      id="ls_start_01"
                      [value]="formData.ls_start_01"
                      (change)="updateFormValue('ls_start_01', $event)"
                      (keydown)="disableInput($event)"
                    />
                  </div>
                </div>
                <div class="col-span-2 w-full">
                  <label
                    for="ls_end_01"
                    class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                    >End Date
                    <span class="text-red-500" aria-hidden="true"
                      >*</span
                    ></label
                  >
                  <div class="relative max-w-sm">
                    <div
                      class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                    >
                      <svg
                        class="w-4 h-4 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
                        />
                      </svg>
                    </div>
                    <input
                      [min]="waterYearMinDate"
                      [max]="waterYearMaxDate"
                      type="date"
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Select date"
                      id="ls_end_01"
                      [value]="formData.ls_end_01"
                      (change)="updateFormValue('ls_end_01', $event)"
                      (keydown)="disableInput($event)"
                    />
                  </div>
                </div>
              </div>
              <!-- Crop Group 02-->
              @if (!isFallow) {
                <div class="grid gap-4 sm:grid-cols-11 sm:gap-6 mt-5">
                  <!--09: Crop Types 02 and 10: Irrigation Methods 02-->
                  <div class="col-span-4 w-full flex flex-col">
                    <label
                      for="crop_type_02"
                      class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                      >Crop 2</label
                    >
                    <app-dropdown
                      class="text-xs 2xl:text-sm"
                      [dropdownPlacement]="'top'"
                      [useSearch]="true"
                      [options]="cropsNoFallow ?? []"
                      [selectedKey]="selectedCrops(formData.crop_type_02 ?? '')"
                      [hasNoneOption]="true"
                      [noneOutputValue]="'None'"
                      keyField="id"
                      labelField="crop_type"
                      outputField="crop_type"
                      (onClickOption)="updateFormValue('crop_type_02', $event)"
                    />
                  </div>
                  <div class="col-span-3 w-full">
                    <label
                      for="irrigation_methods_02"
                      class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                      >{{ irrigationDropdownLabel }}</label
                    >
                    <select
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      id="irrigation_methods_02"
                      [value]="
                        formData.irrigation_methods_02 === null ?
                          'None'
                        : formData.irrigation_methods_02[0]
                      "
                      (change)="
                        updateFormValue('irrigation_methods_02', $event)
                      "
                    >
                      <option value="None">None</option>
                      <option value="Drip">Drip</option>
                      <option value="Microsprinkler/Microsprayer">
                        Microsprinkler/Microsprayer
                      </option>
                      <option value="Sprinkler">Sprinkler</option>
                      <option value="Furrow">Furrow</option>
                      <option value="Border Strip">Border Strip</option>
                      <option value="Basin">Basin</option>
                      <option value="Flood">Flood</option>
                      <option value="Center Pivot">Center Pivot</option>
                      <option value="Linear Move">Linear Move</option>
                      <option value="Non-irrigated">Non-irrigated</option>
                    </select>
                  </div>
                  <!--Start and End Dates-->
                  <div class="col-span-2 w-full">
                    <label
                      for="ls_start_02"
                      class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                      >Start Date</label
                    >
                    <div class="relative max-w-sm">
                      <div
                        class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                      >
                        <svg
                          class="w-4 h-4 text-gray-500 dark:text-gray-400"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
                          />
                        </svg>
                      </div>
                      <input
                        [min]="waterYearMinDate"
                        [max]="waterYearMaxDate"
                        type="date"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Select date"
                        id="ls_start_02"
                        [value]="
                          formData.ls_start_02 === null ?
                            ''
                          : formData.ls_start_02
                        "
                        (change)="updateFormValue('ls_start_02', $event)"
                        (keydown)="disableInput($event)"
                      />
                    </div>
                  </div>
                  <div class="col-span-2 w-full">
                    <label
                      for="ls_end_02"
                      class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                      >End Date</label
                    >
                    <div class="relative max-w-sm">
                      <div
                        class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                      >
                        <svg
                          class="w-4 h-4 text-gray-500 dark:text-gray-400"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
                          />
                        </svg>
                      </div>
                      <input
                        [min]="waterYearMinDate"
                        [max]="waterYearMaxDate"
                        type="date"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Select date"
                        id="ls_end_02"
                        [value]="
                          formData.ls_end_02 === null ? '' : formData.ls_end_02
                        "
                        (change)="updateFormValue('ls_end_02', $event)"
                        (keydown)="disableInput($event)"
                      />
                    </div>
                  </div>
                </div>
              }
              <!-- Crop Group 03-->
              @if (!isFallow) {
                <div class="grid gap-4 sm:grid-cols-11 sm:gap-6 mt-5">
                  <!--13: Crop Types 03 and 14: Irrigation Methods 03-->
                  <div class="col-span-4 w-full flex flex-col">
                    <label
                      for="crop_type_03"
                      class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                      >Crop 3</label
                    >
                    <!-- (change)="onChangeClient($event)" -->
                    <app-dropdown
                      class="text-xs 2xl:text-sm"
                      [dropdownPlacement]="'top'"
                      [useSearch]="true"
                      [options]="cropsNoFallow ?? []"
                      [selectedKey]="selectedCrops(formData.crop_type_03 ?? '')"
                      [hasNoneOption]="true"
                      [noneOutputValue]="'None'"
                      keyField="id"
                      labelField="crop_type"
                      outputField="crop_type"
                      (onClickOption)="updateFormValue('crop_type_03', $event)"
                    />
                  </div>
                  <div class="col-span-3 w-full">
                    <label
                      for="irrigation_methods_03"
                      class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                      >{{ irrigationDropdownLabel }}</label
                    >
                    <select
                      id="category"
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      id="irrigation_methods_03"
                      [value]="
                        formData.irrigation_methods_03 === null ?
                          'None'
                        : formData.irrigation_methods_03[0]
                      "
                      (change)="
                        updateFormValue('irrigation_methods_03', $event)
                      "
                    >
                      <option value="None">None</option>
                      <option value="Drip">Drip</option>
                      <option value="Microsprinkler/Microsprayer">
                        Microsprinkler/Microsprayer
                      </option>
                      <option value="Sprinkler">Sprinkler</option>
                      <option value="Furrow">Furrow</option>
                      <option value="Border Strip">Border Strip</option>
                      <option value="Basin">Basin</option>
                      <option value="Flood">Flood</option>
                      <option value="Center Pivot">Center Pivot</option>
                      <option value="Linear Move">Linear Move</option>
                      <option value="Non-irrigated">Non-irrigated</option>
                    </select>
                  </div>
                  <!--15: Start 03 and 16: End 03-->
                  <div class="col-span-2 w-full">
                    <label
                      for="ls_start_03"
                      class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                      >Start Date</label
                    >
                    <div class="relative max-w-sm">
                      <div
                        class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                      >
                        <svg
                          class="w-4 h-4 text-gray-500 dark:text-gray-400"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
                          />
                        </svg>
                      </div>
                      <input
                        [min]="waterYearMinDate"
                        [max]="waterYearMaxDate"
                        type="date"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Select date"
                        id="ls_start_03"
                        [value]="
                          formData.ls_start_03 === null ?
                            ''
                          : formData.ls_start_03
                        "
                        (change)="updateFormValue('ls_start_03', $event)"
                        (keydown)="disableInput($event)"
                      />
                    </div>
                  </div>
                  <div class="col-span-2 w-full">
                    <label
                      for="ls_end_03"
                      class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                      >End Date</label
                    >
                    <div class="relative max-w-sm">
                      <div
                        class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                      >
                        <svg
                          class="w-4 h-4 text-gray-500 dark:text-gray-400"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
                          />
                        </svg>
                      </div>
                      <input
                        type="date"
                        [min]="waterYearMinDate"
                        [max]="waterYearMaxDate"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Select date"
                        id="ls_end_03"
                        [value]="
                          formData.ls_end_03 === null ? '' : formData.ls_end_03
                        "
                        (change)="updateFormValue('ls_end_03', $event)"
                        [readonly]
                      />
                    </div>
                  </div>
                </div>
              }
              @if (!owner && hasPreclaimedInfoForClaim) {
                <label
                  for="preclaimedInfoAcknowledged"
                  class="mt-5 flex items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-xs font-medium text-amber-950 dark:border-amber-500/50 dark:bg-amber-900/30 dark:text-amber-100 2xl:text-sm"
                >
                  <input
                    id="preclaimedInfoAcknowledged"
                    type="checkbox"
                    class="mt-0.5 h-4 w-4 shrink-0 rounded border-amber-400 bg-white text-blue-600 focus:ring-2 focus:ring-blue-500 dark:border-amber-500 dark:bg-gray-700 dark:ring-offset-gray-800 dark:focus:ring-blue-600"
                    [checked]="preclaimedInfoAcknowledged"
                    (change)="updatePreclaimedInfoAcknowledgement($event)"
                  />
                  <span class="leading-5">
                    I confirm the pre-populated field information above is
                    accurate or has been updated as needed.
                    <span class="text-red-600 dark:text-red-300">*</span>
                  </span>
                  <app-info-popover
                    class="mt-0.5 shrink-0"
                    [infoType]="'preclaimedAcknowledgement'"
                  ></app-info-popover>
                </label>
              }
              <!--Submit Button-->
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-4">
                  @if (this.authService.internalModeValue !== "demo") {
                    <button
                      type="button"
                      class="text-white inline-flex items-center px-5 py-2.5 mb-3 mt-8 sm:mt-8 text-xs 2xl:text-sm font-medium text-center rounded-lg focus:ring-4 focus:ring-primary-200 dark:focus:ring-primary-900 hover:bg-primary-800"
                      (click)="onSubmitCropRecords()"
                      [ngClass]="{
                        'bg-blue-700 hover:bg-primary-800': isFormValid,
                        'bg-blue-400 cursor-not-allowed': !isFormValid,
                      }"
                      [disabled]="!isFormValid"
                    >
                      {{ owner ? "UPDATE" : "SUBMIT" }}
                    </button>
                    <p
                      class="mt-2 text-xs 2xl:text-sm text-red-600 dark:text-red-500"
                    >
                      <span class="font-medium">
                        <div
                          [ngClass]="{
                            block: !isFormValid,
                            hidden: isFormValid,
                          }"
                        >
                          {{ validationInfo }}
                        </div>
                      </span>
                    </p>
                  } @else {
                    <div class="mt-8"></div>
                  }
                </div>
                <!-- If the current login user claim the field before, initialize the delete button -->
                @if (owner && this.authService.internalModeValue !== "demo") {
                  <button
                    type="button"
                    class="inline-flex items-center px-5 py-2.5 mb-3 mt-8 sm:mt-8 text-xs 2xl:text-sm font-medium text-center text-white bg-red-600 rounded-lg focus:ring-4 focus:ring-red-200 dark:focus:ring-red-900 hover:bg-primary-800"
                    (click)="onDeleteCropRecords()"
                  >
                    DELETE
                  </button>
                }
              </div>
            </form>
          </div>
        </section>
      } @else {
        <section class="bg-white dark:bg-gray-900">
          <div class="px-4 mx-auto max-w-5xl">
            <!-- Title, update or claim field -->
            <h2
              class="mb-4 text-base 2xl:text-xl font-bold text-gray-900 dark:text-white"
            >
              {{ owner ? "Update the Field" : "Claim a New Field" }}
            </h2>
            <form>
              <!-- Claim As (Manager only) -->
              <div class="flex flex-col gap-2">
                <label
                  class="text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                  >Claim As</label
                >
                <app-dropdown
                  class="text-xs 2xl:text-sm"
                  [options]="claimAsOptionList()"
                  [keyField]="'key'"
                  [labelField]="'label'"
                  [outputField]="'key'"
                  [dropdownPlacement]="'bottom'"
                  [(selectedKey)]="selectedClaimAsUserId"
                  [useSearch]="true"
                  [disabled]="isAwaitingClaimAsConfirm"
                />
              </div>
              <hr class="my-4 border-gray-200 dark:border-gray-700" />
              <!-- 01: Field Name -->
              <div class="grid gap-4 sm:grid-cols-2 sm:gap-6">
                <div class="sm:col-span-2">
                  <label
                    for="fieldName"
                    class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                    >Field Name
                    <span class="text-red-500" aria-hidden="true"
                      >*</span
                    ></label
                  >
                  <input
                    type="text"
                    name="fieldName"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                    placeholder="Name the Field"
                    id="fieldName"
                    [value]="formData.field_name"
                    (input)="updateFormValue('field_name', $event)"
                  />
                </div>
              </div>
              <!-- Entity Group: shown only when manager is claiming on
                   behalf of a grower (Claim As is set to a grower). -->
              @if (showEntitySection()) {
                <ng-container *ngTemplateOutlet="entitySectionTpl" />
              }
              <!-- Target Water Group -->
              <div class="grid gap-4 sm:grid-cols-11 sm:gap-6 mt-5">
                <!-- 02: Total Target Water -->
                <div class="sm:col-span-4">
                  <label
                    for="total_target_water"
                    class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                    >Total Target Water
                    <span class="text-red-500" aria-hidden="true"
                      >*</span
                    ></label
                  >
                  <input
                    type="number"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                    placeholder="Type Your Total Target Water"
                    id="total_target_water"
                    [value]="formData.total_target_water"
                    (change)="updateFormValue('total_target_water', $event)"
                  />
                </div>
                <!-- 03: Total Target Type -->
                <div class="sm:col-span-3">
                  <label
                    for="total_target_type"
                    class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                    >Target Type
                    <span class="text-red-500" aria-hidden="true"
                      >*</span
                    ></label
                  >
                  <select
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                    id="total_target_type"
                    [value]="formData.total_target_type"
                    (change)="updateFormValue('total_target_type', $event)"
                  >
                    <option value="ET">ET</option>
                    <option value="Applied Water">Applied Water</option>
                  </select>
                </div>
                <!-- 04: Total Target Water Unit -->
                <div class="sm:col-span-2">
                  <label
                    for="total_target_water_unit"
                    class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                    >Water Unit
                    <span class="text-red-500" aria-hidden="true"
                      >*</span
                    ></label
                  >
                  <select
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                    id="total_target_water_unit"
                    [value]="formData.total_target_water_unit"
                    (change)="
                      updateFormValue('total_target_water_unit', $event)
                    "
                  >
                    <option value="Feet">Feet</option>
                    <option value="Inches">Inches</option>
                  </select>
                </div>
                <!-- Deficit Irrigation -->
                <div class="sm:col-span-2">
                  <div class="gap-2 flex flex-col">
                    <div class="flex flex-row items-center gap-2">
                      <label
                        for="is_deficit_irrigation"
                        class="block text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                        >Deficit Irrigation</label
                      >
                      <app-graph-popover-instruction
                        [infoType]="'deficitIrrigation'"
                      />
                    </div>
                    <app-dropdown
                      class="text-xs 2xl:text-sm"
                      [dropdownPlacement]="'bottom'"
                      [options]="deficitIrrigationOptions"
                      [selectedKey]="formData.is_deficit_irrigation ?? ''"
                      [hasNoneOption]="true"
                      [noneOutputValue]="null"
                      [noneLabel]="''"
                      keyField="value"
                      labelField="label"
                      outputField="value"
                      (onClickOption)="
                        updateFormValue('is_deficit_irrigation', $event)
                      "
                    />
                  </div>
                </div>
              </div>
              <!-- Crop Group 01-->
              <div class="grid gap-4 sm:grid-cols-11 sm:gap-6 mt-5">
                <!--05: Crop Types 01 and 06: Irrigation Methods 01-->
                <div class="col-span-4 w-full flex flex-col">
                  <div class="flex flex-row items-center gap-1 mb-2">
                    <label
                      for="crop_type_01"
                      class="block text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                      >Crop 1
                      <span class="text-red-500" aria-hidden="true"
                        >*</span
                      ></label
                    >
                    <app-graph-popover-instruction
                      [placement]="'right'"
                      [infoType]="'coverCrop'"
                    />
                  </div>
                  <app-dropdown
                    class="text-xs 2xl:text-sm"
                    *ngIf="visible"
                    [dropdownPlacement]="'bottom'"
                    [useSearch]="true"
                    [options]="crops ?? []"
                    [selectedKey]="selectedCrops(formData.crop_type_01)"
                    [hasNoneOption]="false"
                    keyField="id"
                    labelField="crop_type"
                    outputField="crop_type"
                    (onClickOption)="updateFormValue('crop_type_01', $event)"
                  />
                </div>
                <div class="col-span-3 w-full flex flex-col">
                  <label
                    for="irrigation_methods_01"
                    class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                    >{{ irrigationDropdownLabel }}
                    <span class="text-red-500" aria-hidden="true"
                      >*</span
                    ></label
                  >
                  <app-dropdown
                    class="text-xs 2xl:text-sm"
                    [dropdownPlacement]="'bottom'"
                    [options]="irrigationMethodsOptions"
                    [(selectedKey)]="firstCropIrrigationMethodSelectedOption"
                    [hasNoneOption]="false"
                    keyField="key"
                    labelField="value"
                    outputField="value"
                  />
                </div>
                <!--Start and End Dates-->
                <div class="col-span-2 w-full">
                  <label
                    for="ls_start_01"
                    class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                    >Start Date
                    <span class="text-red-500" aria-hidden="true"
                      >*</span
                    ></label
                  >
                  <div class="relative max-w-sm">
                    <div
                      class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                    >
                      <svg
                        class="w-4 h-4 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
                        />
                      </svg>
                    </div>
                    <input
                      [min]="waterYearMinDate"
                      [max]="waterYearMaxDate"
                      type="date"
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Select date"
                      id="ls_start_01"
                      [value]="formData.ls_start_01"
                      (change)="updateFormValue('ls_start_01', $event)"
                      (keydown)="disableInput($event)"
                    />
                  </div>
                </div>
                <div class="col-span-2 w-full">
                  <label
                    for="ls_end_01"
                    class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                    >End Date
                    <span class="text-red-500" aria-hidden="true"
                      >*</span
                    ></label
                  >
                  <div class="relative max-w-sm">
                    <div
                      class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                    >
                      <svg
                        class="w-4 h-4 text-gray-500 dark:text-gray-400"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
                        />
                      </svg>
                    </div>
                    <input
                      [min]="waterYearMinDate"
                      [max]="waterYearMaxDate"
                      type="date"
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Select date"
                      id="ls_end_01"
                      [value]="formData.ls_end_01"
                      (change)="updateFormValue('ls_end_01', $event)"
                      (keydown)="disableInput($event)"
                    />
                  </div>
                </div>
              </div>
              <!-- Crop Group 02-->
              @if (!isFallow) {
                <div class="grid gap-4 sm:grid-cols-11 sm:gap-6 mt-5">
                  <!--09: Crop Types 02 and 10: Irrigation Methods 02-->
                  <div class="col-span-4 w-full">
                    <label
                      for="crop_type_02"
                      class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                      >Crop 2</label
                    >
                    <!-- (change)="onChangeClient($event)" -->
                    <select
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      id="crop_type_02"
                      [value]="
                        formData.crop_type_02 === null ?
                          'None'
                        : formData.crop_type_02
                      "
                      (change)="updateFormValue('crop_type_02', $event)"
                    >
                      <option value="None">None</option>
                      @for (crop of crops; track crop.id) {
                        <option value="{{ crop.crop_type }}">
                          {{ crop.crop_type }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="col-span-3 w-full">
                    <label
                      for="irrigation_methods_02"
                      class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                      >{{ irrigationDropdownLabel }}</label
                    >
                    <select
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      id="irrigation_methods_02"
                      [value]="
                        formData.irrigation_methods_02 === null ?
                          'None'
                        : formData.irrigation_methods_02[0]
                      "
                      (change)="
                        updateFormValue('irrigation_methods_02', $event)
                      "
                    >
                      <option value="None">None</option>
                      <option value="Drip">Drip</option>
                      <option value="Microsprinkler/Microsprayer">
                        Microsprinkler/Microsprayer
                      </option>
                      <option value="Sprinkler">Sprinkler</option>
                      <option value="Furrow">Furrow</option>
                      <option value="Border Strip">Border Strip</option>
                      <option value="Basin">Basin</option>
                      <option value="Flood">Flood</option>
                      <option value="Center Pivot">Center Pivot</option>
                      <option value="Linear Move">Linear Move</option>
                      <option value="Non-irrigated">Non-irrigated</option>
                    </select>
                  </div>
                  <!--Start and End Dates-->
                  <div class="col-span-2 w-full">
                    <label
                      for="ls_start_02"
                      class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                      >Start Date</label
                    >
                    <div class="relative max-w-sm">
                      <div
                        class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                      >
                        <svg
                          class="w-4 h-4 text-gray-500 dark:text-gray-400"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
                          />
                        </svg>
                      </div>
                      <input
                        [min]="waterYearMinDate"
                        [max]="waterYearMaxDate"
                        type="date"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Select date"
                        id="ls_start_02"
                        [value]="
                          formData.ls_start_02 === null ?
                            ''
                          : formData.ls_start_02
                        "
                        (change)="updateFormValue('ls_start_02', $event)"
                        (keydown)="disableInput($event)"
                      />
                    </div>
                  </div>
                  <div class="col-span-2 w-full">
                    <label
                      for="ls_end_02"
                      class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                      >End Date</label
                    >
                    <div class="relative max-w-sm">
                      <div
                        class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                      >
                        <svg
                          class="w-4 h-4 text-gray-500 dark:text-gray-400"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
                          />
                        </svg>
                      </div>
                      <input
                        [min]="waterYearMinDate"
                        [max]="waterYearMaxDate"
                        type="date"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Select date"
                        id="ls_end_02"
                        [value]="
                          formData.ls_end_02 === null ? '' : formData.ls_end_02
                        "
                        (change)="updateFormValue('ls_end_02', $event)"
                        (keydown)="disableInput($event)"
                      />
                    </div>
                  </div>
                </div>
              }
              <!-- Crop Group 03-->
              @if (!isFallow) {
                <div class="grid gap-4 sm:grid-cols-11 sm:gap-6 mt-5">
                  <!--13: Crop Types 03 and 14: Irrigation Methods 03-->
                  <div class="col-span-4 w-full">
                    <label
                      for="crop_type_03"
                      class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                      >Crop 3</label
                    >
                    <!-- (change)="onChangeClient($event)" -->
                    <select
                      id="category"
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      id="crop_type_03"
                      [value]="
                        formData.crop_type_03 === null ?
                          'None'
                        : formData.crop_type_03
                      "
                      (change)="updateFormValue('crop_type_03', $event)"
                    >
                      <option value="None">None</option>
                      @for (crop of crops; track crop.id) {
                        <option value="{{ crop.crop_type }}">
                          {{ crop.crop_type }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="col-span-3 w-full">
                    <label
                      for="irrigation_methods_03"
                      class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                      >{{ irrigationDropdownLabel }}</label
                    >
                    <select
                      id="category"
                      class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      id="irrigation_methods_03"
                      [value]="
                        formData.irrigation_methods_03 === null ?
                          'None'
                        : formData.irrigation_methods_03[0]
                      "
                      (change)="
                        updateFormValue('irrigation_methods_03', $event)
                      "
                    >
                      <option value="None">None</option>
                      <option value="Drip">Drip</option>
                      <option value="Microsprinkler/Microsprayer">
                        Microsprinkler/Microsprayer
                      </option>
                      <option value="Sprinkler">Sprinkler</option>
                      <option value="Furrow">Furrow</option>
                      <option value="Border Strip">Border Strip</option>
                      <option value="Basin">Basin</option>
                      <option value="Flood">Flood</option>
                      <option value="Center Pivot">Center Pivot</option>
                      <option value="Linear Move">Linear Move</option>
                      <option value="Non-irrigated">Non-irrigated</option>
                    </select>
                  </div>
                  <!--15: Start 03 and 16: End 03-->
                  <div class="col-span-2 w-full mb-10">
                    <label
                      for="ls_start_03"
                      class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                      >Start Date</label
                    >
                    <div class="relative max-w-sm">
                      <div
                        class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                      >
                        <svg
                          class="w-4 h-4 text-gray-500 dark:text-gray-400"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
                          />
                        </svg>
                      </div>
                      <input
                        [min]="waterYearMinDate"
                        [max]="waterYearMaxDate"
                        type="date"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Select date"
                        id="ls_start_03"
                        [value]="
                          formData.ls_start_03 === null ?
                            ''
                          : formData.ls_start_03
                        "
                        (change)="updateFormValue('ls_start_03', $event)"
                        (keydown)="disableInput($event)"
                      />
                    </div>
                  </div>
                  <div class="col-span-2 w-full">
                    <label
                      for="ls_end_03"
                      class="block mb-2 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                      >End Date</label
                    >
                    <div class="relative max-w-sm">
                      <div
                        class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none"
                      >
                        <svg
                          class="w-4 h-4 text-gray-500 dark:text-gray-400"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
                          />
                        </svg>
                      </div>
                      <input
                        type="date"
                        [min]="waterYearMinDate"
                        [max]="waterYearMaxDate"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Select date"
                        id="ls_end_03"
                        [value]="
                          formData.ls_end_03 === null ? '' : formData.ls_end_03
                        "
                        (change)="updateFormValue('ls_end_03', $event)"
                        [readonly]
                      />
                    </div>
                  </div>
                </div>
              }
              <!--Submit Button-->
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-4">
                  @if (this.authService.internalModeValue !== "demo") {
                    <button
                      type="button"
                      class="text-white inline-flex items-center px-5 py-2.5 mb-3 mt-8 sm:mt-8 text-xs 2xl:text-sm font-medium text-center rounded-lg focus:ring-4 focus:ring-primary-200 dark:focus:ring-primary-900 hover:bg-primary-800"
                      (click)="onSubmitCropRecords()"
                      [ngClass]="{
                        'bg-blue-700 hover:bg-primary-800': isFormValid,
                        'bg-blue-400 cursor-not-allowed': !isFormValid,
                      }"
                      [disabled]="!isFormValid"
                    >
                      {{ owner ? "UPDATE" : "SUBMIT" }}
                    </button>
                    <p
                      class="mt-2 text-xs 2xl:text-sm text-red-600 dark:text-red-500"
                    >
                      <span class="font-medium">
                        <div
                          [ngClass]="{
                            block: !isFormValid,
                            hidden: isFormValid,
                          }"
                        >
                          {{ validationInfo }}
                        </div>
                      </span>
                    </p>
                  } @else {
                    <div class="mt-8"></div>
                  }
                </div>
                <!-- If the field was previously claimed, allow Release/Delete -->
                @if (owner && this.authService.internalModeValue !== "demo") {
                  <button
                    type="button"
                    class="inline-flex items-center px-5 py-2.5 mb-3 mt-8 sm:mt-8 text-xs 2xl:text-sm font-medium text-center text-white bg-red-600 rounded-lg focus:ring-4 focus:ring-red-200 dark:focus:ring-red-900 hover:bg-primary-800"
                    (click)="onDeleteCropRecords()"
                  >
                    DELETE
                  </button>
                }
              </div>
            </form>
          </div>
        </section>
      }
      <!-- Modal footer -->
      <div
        class="flex items-center py-2 md:py-2 space-x-3 rtl:space-x-reverse border-gray-200 rounded-b dark:border-gray-900"
      ></div>
    </div>
  </div>
</div>

<!-- Entity multi-select section: shared by the grower form and the
     manager-on-behalf form. Bound to `selectedEntities` / `growerEntities`
     state on the component. -->
<ng-template #entitySectionTpl>
  <div class="mt-5">
    <div class="flex flex-row items-center gap-2 mb-2">
      <label
        class="block text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
        >Entities</label
      >
      <app-graph-popover-instruction [infoType]="'entityName'" />
    </div>
    <div class="flex items-start gap-3">
      <!-- Multi-select entity dropdown -->
      <div class="relative flex-1">
        <button
          type="button"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 text-left flex items-center justify-between"
          (click)="toggleEntityDropdown()"
        >
          <span class="truncate">
            @if (selectedEntities.length === 0) {
              Select entities...
            } @else if (selectedEntities.length === 1) {
              {{ selectedEntities[0].name }}
              {{ "{" + selectedEntities[0].email + "}" }}
            } @else {
              {{ selectedEntities.length }} entities selected
            }
          </span>
          <svg
            class="w-3 h-3 ml-2 shrink-0"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 10 6"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 1 4 4 4-4"
            />
          </svg>
        </button>
        <!-- Dropdown panel -->
        @if (showEntityDropdown) {
          <div
            class="absolute z-50 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg dark:bg-gray-700 dark:border-gray-600"
          >
            @if (growerEntities.length > 0) {
              <!-- Select All -->
              <label
                class="flex items-center gap-2 px-3 py-2 border-b border-gray-200 dark:border-gray-600 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-600"
              >
                <input
                  type="checkbox"
                  class="w-4 h-4 cursor-pointer text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600"
                  [checked]="
                    selectedEntities.length === growerEntities.length &&
                    growerEntities.length > 0
                  "
                  [indeterminate]="
                    selectedEntities.length > 0 &&
                    selectedEntities.length < growerEntities.length
                  "
                  (change)="toggleSelectAll()"
                />
                <span
                  class="text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
                  >Select All</span
                >
              </label>
              <!-- Entity list -->
              <ul class="max-h-40 overflow-y-auto">
                @for (entry of growerEntities; track $index) {
                  <li>
                    <label
                      class="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600"
                    >
                      <input
                        type="checkbox"
                        class="w-4 h-4 cursor-pointer text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600"
                        [checked]="isEntitySelected(entry)"
                        (change)="toggleEntitySelection(entry)"
                      />
                      <span
                        class="text-xs 2xl:text-sm text-gray-900 dark:text-white"
                      >
                        {{ entry.name }}
                        <span class="text-gray-400 dark:text-gray-400">{{
                          "{" + entry.email + "}"
                        }}</span>
                      </span>
                    </label>
                  </li>
                }
              </ul>
            } @else {
              <div
                class="px-3 py-2 text-xs 2xl:text-sm text-gray-500 dark:text-gray-400"
              >
                No entities yet. Click "Add New Entity" to create one.
              </div>
            }
          </div>
        }
      </div>
      <!-- Add New Entity button -->
      <button
        type="button"
        class="inline-flex items-center gap-1 px-4 py-2.5 text-xs 2xl:text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 dark:bg-blue-500 dark:hover:bg-blue-600 dark:focus:ring-blue-800 whitespace-nowrap"
        (click)="toggleAddNewEntityForm()"
      >
        <svg
          class="w-3 h-3"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 18 18"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 1v16M1 9h16"
          />
        </svg>
        Add New Entity
      </button>
    </div>
    <!-- Add New Entity inline form -->
    @if (showAddNewEntityForm) {
      <div
        class="mt-3 p-3 bg-gray-50 border border-gray-200 rounded-lg dark:bg-gray-800 dark:border-gray-600"
      >
        <div class="grid gap-3 sm:grid-cols-11">
          <div class="sm:col-span-4">
            <label
              for="newEntityName"
              class="block mb-1 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
              >Entity Name</label
            >
            <input
              type="text"
              id="newEntityName"
              class="bg-white border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
              placeholder="Enter entity name"
              [value]="newEntityName"
              (input)="newEntityName = $any($event.target).value"
            />
          </div>
          <div class="sm:col-span-4">
            <label
              for="newEntityEmail"
              class="block mb-1 text-xs 2xl:text-sm font-medium text-gray-900 dark:text-white"
              >Entity Email</label
            >
            <input
              type="email"
              id="newEntityEmail"
              class="bg-white border border-gray-300 text-gray-900 text-xs 2xl:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
              placeholder="Enter entity email"
              [value]="newEntityEmail"
              (input)="newEntityEmail = $any($event.target).value"
            />
          </div>
          <div class="sm:col-span-3 flex items-end gap-2">
            <button
              type="button"
              class="inline-flex items-center px-4 py-2 text-xs 2xl:text-sm font-medium text-white rounded-lg focus:ring-4"
              [ngClass]="{
                'bg-green-600 hover:bg-green-700 focus:ring-green-300 dark:bg-green-500 dark:hover:bg-green-600':
                  newEntityName.trim() &&
                  newEntityEmail.trim() &&
                  isValidEmail(newEntityEmail.trim()) &&
                  !isCheckingEntityEmail,
                'bg-green-300 cursor-not-allowed dark:bg-green-800':
                  !(
                    newEntityName.trim() &&
                    newEntityEmail.trim() &&
                    isValidEmail(newEntityEmail.trim())
                  ) || isCheckingEntityEmail,
              }"
              [disabled]="
                !(
                  newEntityName.trim() &&
                  newEntityEmail.trim() &&
                  isValidEmail(newEntityEmail.trim())
                ) || isCheckingEntityEmail
              "
              (click)="addNewEntity()"
            >
              {{ isCheckingEntityEmail ? "Checking..." : "Save" }}
            </button>
            <button
              type="button"
              class="inline-flex items-center px-4 py-2 text-xs 2xl:text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-600"
              (click)="toggleAddNewEntityForm()"
            >
              Cancel
            </button>
          </div>
        </div>
        @if (newEntityValidationMsg) {
          <p class="mt-2 text-xs text-red-600 dark:text-red-500">
            {{ newEntityValidationMsg }}
          </p>
        }
      </div>
    }
    <!-- Selected entities chips -->
    @if (selectedEntities.length > 0) {
      <div class="flex flex-wrap gap-2 mt-2">
        @for (entry of selectedEntities; track entry.email) {
          <span
            class="inline-flex items-center gap-1 px-2 py-1 text-xs 2xl:text-sm font-medium text-blue-800 bg-blue-100 rounded-full dark:bg-blue-900 dark:text-blue-200"
          >
            {{ entry.name }} {{ "{" + entry.email + "}" }}
            <button
              type="button"
              class="inline-flex items-center p-0.5 text-blue-400 hover:text-blue-900 dark:hover:text-white"
              (click)="toggleEntitySelection(entry)"
            >
              <svg
                class="w-2.5 h-2.5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
            </button>
          </span>
        }
      </div>
    }
  </div>
</ng-template>
